import React, { useEffect } from 'react';
import './index.scss'
import FilterSection from './children/FilterSection';
import ChartWrapper from './children/ChartWrapper';

const BenchmarkAnalysis = (props) => {



    return (
        <>
            <FilterSection />
            <ChartWrapper />

        </>
    );
};

export default BenchmarkAnalysis;

